import { HomePageContainer } from "./HomePageStyled";

function HomePage() {
  return (
    <HomePageContainer>
      <p className="placeholder-text">メニューから機能を選択してください。</p>
    </HomePageContainer>
  );
}

export { HomePage };
